import { ctaDesc, ctaTitle } from "@/lib/seo";
import { createFileRoute, notFound } from "@tanstack/react-router";
import VisaProductPage from "@/components/VisaProductPage";
import { getVisaProduct, VISA_PRODUCTS } from "@/data/visa-products";
import { visaProductGraph, defaultVisaProductFaqs } from "@/lib/visa-product-schema";
import { BRAND_URL } from "@/lib/brand";

export const Route = createFileRoute("/visa/products/$slug")({
  loader: ({ params }) => {
    const p = getVisaProduct(params.slug);
    if (!p) throw notFound();
    return { product: p };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) return { meta: [{ title: ctaTitle("ไม่พบวีซ่า", "/visa/products/$slug", "th")}, { name: "robots", content: "noindex" }] };
    const p = loaderData.product;
    const path = `/visa/products/${params.slug}`;
    const url = `${BRAND_URL}${path}`;
    const title = `${p.nameTh} (${p.visa.code}) | ยื่นครบขั้นตอน · ${p.turnaround}`;
    const desc = p.shortDescTh + " · บริการยื่นวีซ่าครบวงจร โดยที่ปรึกษาด้านตรวจคนเข้าเมือง — เตรียมเอกสาร, ยื่น ตม./BOI/กงสุล, ติดตามผลจนอนุมัติ";
    const faqs = defaultVisaProductFaqs(p, "th");
    return {
      meta: [
        { title: ctaTitle(title, "/visa/products/$slug", "th") }, { name: "description", content: ctaDesc(desc, "/visa/products/$slug", "th")},
        { property: "og:title", content: ctaTitle(title, "/visa/products/$slug", "th")},
        { property: "og:description", content: ctaDesc(desc, "/visa/products/$slug", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "product" },
        { property: "og:locale", content: "th_TH" },
        { property: "product:price:amount", content: String(p.priceMid) },
        { property: "product:price:currency", content: "THB" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: url },
        { rel: "alternate", hrefLang: "en", href: `${BRAND_URL}/en/visa/products/${params.slug}` },
        { rel: "alternate", hrefLang: "x-default", href: url },
      ],
      scripts: [{
        type: "application/ld+json",
        children: JSON.stringify(visaProductGraph({ product: p, locale: "th", path, faqs })),
      }],
    };
  },
  notFoundComponent: () => <div className="p-16 text-center">ไม่พบวีซ่าที่ค้นหา</div>,
  component: () => {
    const { product } = Route.useLoaderData();
    return <VisaProductPage product={product} locale="th" faqs={defaultVisaProductFaqs(product, "th")} />;
  },
});

export const VISA_PRODUCT_SLUGS = VISA_PRODUCTS.map((p) => p.slug);
